import React from 'react';

import Button from '../../elements/Button';
import content from './content';
import Point from '../../elements/Point';

import icon1 from './images/fee.png';
import icon2 from './images/code.png';

import './style.scss';

function JoinFooter(props) {
    const { id, locale = '' } = props;
    const joinFooterItems =
        locale === ''
            ? content['joinFooterItems']
            : content[locale.replace('-', '') + '_joinFooterItems'];

    let data = joinFooterItems[id];
    if (!data) {
        data = joinFooterItems['root'];
    }

    const {
        title,
        text,
        but1,
        but2,
        col1Header,
        col1Text,
        col1Btn,
        col2Header,
        col2Text,
        col2Btn,
    } = data;

    const tag = ['container joinFooter-container no-gutter mx-auto', id];

    return (
        <div className={id === 'compliance' ? tag.join(' ') : tag[0]}>
            { props.page !== 'NotFoundPage' &&
                <div className="row g-0">
                <div className="col-lg-6 pe-lg-5 left-panel">
                    <h2>{title}</h2>
                    <p className="segment-text">{text}</p>
                    <Button src={but1.link} value={but1.text} />
                    <Button src={but2.link} value={but2.text} option="transparent" />
                </div>

                <Point
                    className="col-12 col-md-6 col-lg-3 right-panel"
                    image={icon1}
                    header={col1Header}
                    text={col1Text}
                    button={col1Btn}
                    option="transparent"
                />

                <Point
                    className="col-12 col-md-6 col-lg-3 right-panel"
                    image={icon2}
                    header={col2Header}
                    text={col2Text}
                    button={col2Btn}
                    option="transparent"
                />
            </div>}
            <hr className="divider" />
        </div>
    );
}

export default JoinFooter;
